import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from '../configuration/configuration.service';
import { PathsService } from '../paths/paths.service';
import { RestApiService } from '../rest-api/rest-api.service';
import { UrlService } from '../url/url.service';

@Injectable({ providedIn: 'root' })
export class CartService {
    private _$cart: BehaviorSubject<any> = new BehaviorSubject(null);
    private _$itemsNumber: BehaviorSubject<Number> = new BehaviorSubject(0);
    private _$coursesInCart: BehaviorSubject<Number> = new BehaviorSubject(0);
    private _$activeStep: BehaviorSubject<number> = new BehaviorSubject(0);
    public ordersent = false;

    constructor(
        private http: HttpClient,
        private _restApi: RestApiService,
        private _urlService: UrlService,
        private _router: Router,
        private config: ConfigurationService,
        private _pathsService: PathsService,
        private _restApiService: RestApiService,
        private _localizeRouterService: LocalizeRouterService
    ) {}

    public get cart$(): Observable<any> {
        return this._$cart.asObservable();
    }

    public get itemsNumber$(): Observable<Number> {
        return this._$itemsNumber.asObservable();
    }

    public get coursesInCart$(): Observable<Number> {
        return this._$coursesInCart.asObservable();
    }

    public get activeStep$(): Observable<number> {
        return this._$activeStep.asObservable();
    }

    addEventToCart(eventId: string) {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        let cartItems = {
            courses: [],
            events: [],
            wishlist: []
        };

        if (localStorage.getItem(`cartItems${_site}`)) {
            cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));
        }

        cartItems.events.push(eventId);
        if (this._$cart) this._$cart.next(cartItems);

        localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(cartItems)));

        let itemsNumber = cartItems.events.length + cartItems.courses.length + cartItems.wishlist.length;
        localStorage.setItem(`itemsNumber${_site}`, itemsNumber.toString());
        this._$itemsNumber.next(itemsNumber);
    }

    addCourseToCart(courseId: string) {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        let cartItems = {
            courses: [],
            events: [],
            wishlist: []
        };

        if (localStorage.getItem(`cartItems${_site}`) && localStorage.getItem(`cartItems${_site}`).length > 0) {
            cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));
        }

        cartItems.courses.push(courseId);

        if (this._$cart) this._$cart.next(cartItems);

        localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(cartItems)));

        let itemsNumber = cartItems.events.length + cartItems.courses.length + cartItems.wishlist.length;
        localStorage.setItem(`itemsNumber${_site}`, itemsNumber.toString());
        this._$itemsNumber.next(itemsNumber);
    }

    addCourseToWishlist(courseId: string) {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        let cartItems = {
            courses: [],
            events: [],
            wishlist: []
        };
        let cartItemsStorage;

        if (localStorage.getItem(`cartItems${_site}`) && localStorage.getItem(`cartItems${_site}`).length > 0) {
            cartItemsStorage = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));
            if (cartItemsStorage.events) cartItems.events = cartItemsStorage.events;
            if (cartItemsStorage.courses) cartItems.courses = cartItemsStorage.courses;
            if (cartItemsStorage.wishlist) cartItems.wishlist = cartItemsStorage.wishlist;
        }

        cartItems.wishlist.push(courseId);

        if (this._$cart) this._$cart.next(cartItems);

        localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(cartItems)));

        let itemsNumber = cartItems.events.length + cartItems.courses.length + cartItems.wishlist.length;
        localStorage.setItem(`itemsNumber${_site}`, itemsNumber.toString());
        this._$itemsNumber.next(itemsNumber);
    }

    removeFromCartItem(course) {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }

        let cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));

        let filteredCartItems = {
            courses: [],
            events: [],
            wishlist: []
        };

        if (cartItems.courses !== null || cartItems.events !== null || cartItems.wishlist !== null) {
            let courses = cartItems.courses.filter((courseItem) => course.externalId !== courseItem);
            let events = cartItems.events.filter((courseItem) => course.externalId !== courseItem);
            let wishlist;
            if (cartItems.wishlist) wishlist = cartItems.wishlist.filter((courseItem) => course.externalId !== courseItem);
            filteredCartItems.events = events;
            filteredCartItems.courses = courses;
            filteredCartItems.wishlist = wishlist;
            localStorage.setItem(`cartItems${_site}`, this._urlService.encode(JSON.stringify(filteredCartItems)));

            let itemsNumber = Number(localStorage.getItem(`itemsNumber${_site}`));
            itemsNumber = itemsNumber - 1;
            localStorage.setItem(`itemsNumber${_site}`, itemsNumber.toString());
            this._$itemsNumber.next(itemsNumber);

            if (this._$cart) this._$cart.next(cartItems);
        }
    }

    clearCart() {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }
        localStorage.removeItem(`cartItems${_site}`);
        localStorage.setItem(`itemsNumber${_site}`, '0');
        localStorage.removeItem(`itemsNumber${_site}`);
        localStorage.removeItem(`currencyOfCartItems${_site}`);
        this._$itemsNumber.next(0);
        this.config.updateIfBillingContactEdited(false);
        this.config.updateloggedInByPopup(false);
    }

    itemsNumber() {
        let _site = this.config.getCurrentSite();
        if (this.config.isPartnerPage()) {
            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }
        let numberItems = localStorage.getItem(`itemsNumber${_site}`);
        this._$itemsNumber.next(Number(numberItems));
        return this.itemsNumber$;
    }

    activeStep(step) {
        this._$activeStep.next(step);
        return this.activeStep$;
    }

    goToCart() {
        let _checkoutPath = this._pathsService.getCheckoutLink();
        const _isPortal = this.config.isPartnerPage();

        if (_isPortal) {
            this.config.currentPortal$.subscribe((portalId) => {
                _checkoutPath = '/partner/' + portalId + '/order-process';
            });
        } else {
            _checkoutPath = this._localizeRouterService.translateRoute('/checkout');
        }

        this.activeStep(0);
        this._$activeStep.next(0);
        this._router.navigate([_checkoutPath]);
    }

    checkPrerequirements(itemId) {
        let _site = this.config.getCurrentSite();

        let params = '';
        if (this.config.isPartnerPage()) {
            // todo: change to portalId when backend is adjusted
            //_site = 'de_de';

            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    let temp = portalId.toLocaleUpperCase().replace('-', '_').replace('-', '_');
                    params = `?portalName=${temp}`;
                }
            });
        } else {
            params = `?countryCode=${_site}`;
        }

        let url = `${environment.APIEndpoint}api/v1/booking/checkprerequisites/${itemId}${params}`;

        if (itemId) {
            this._restApiService.requestGET<boolean>(url, null, false, true).then(
                (data) => {
                    return data;
                },
                (error) => {
                    console.log(error);
                    return false;
                }
            );
        } else {
            return false;
        }
    }

    checkPrerequirementsOfUser(itemId) {
        let _site = this.config.getCurrentSite();

        let params = '';
        if (this.config.isPartnerPage()) {
            // todo: change to portalId when backend is adjusted
            //_site = 'de_de';

            this.config.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    let temp = portalId.toLocaleUpperCase().replace('-', '_').replace('-', '_');
                    params = `?portalName=${temp}`;
                }
            });
        } else {
            params = `?countryCode=${_site}`;
        }

        let url = `${environment.APIEndpoint}api/v1/booking/checkprerequisites/${itemId}${params}`;

        return this._restApiService.requestGET<boolean>(url, null, false, true).then(
            (data) => {
                return true;
            },
            (error) => {
                console.log(error);
                return false;
            }
        );
    }

    public updateActiveAtep(step) {
        this._$activeStep.next(step);
    }
}
